import Vue from 'vue';
import ConfirmV2 from '@/components/copyright/basics/confirmV2/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const TsaConfirmV2 = vue.extend(ConfirmV2)
    if (!$vm) {
      $vm = new TsaConfirmV2({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const toast = {
      show (options = {}) {
        $vm.show = true
        $vm.title = options.title || '提示'
        $vm.message = options.message
        $vm.type = options.type || 'warn'
        $vm.cancelButtonText = options.cancelButtonText || '取消'
        $vm.confirmButtonText = options.confirmButtonText || '确定'
        $vm.onClose = options.onClose
        $vm.onCancel = options.onCancel
        $vm.onConfirm = options.onConfirm
        $vm.onOpen = options.onOpen
      },
      hide () {
        $vm.show = false
        $vm.loading = false
      }
    }
    if (!vue.prototype.$TsaConfirmV2) {
      vue.prototype.$TsaConfirmV2 = toast
    }
  }
}
export default plugin